import { Box } from '@mui/material'
import TablePagination from '@mui/material/TablePagination'

export default function AdxPaginationNew({ ...rest }) {
  return (
    <Box sx={{ borderTop: '1px solid', borderColor: 'gray-line.main' }}>
      <TablePagination
        {...rest}
        component="div"
        labelRowsPerPage="Show"
        SelectProps={{ sx: { borderRadius: 1 } }}
        showFirstButton
        showLastButton
        rowsPerPageOptions={[5, 10, 20, 50]}
      />
    </Box>
  )
}
